import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Button, Modal, Popover, message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { deleteLicense } from '../../utils/apiBucherVaslin';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const { confirm } = Modal;

const showDeleteConfirm = (intl, guid, refresh, isLicenseChild) => {
    confirm({
        title: intl.formatMessage(
            {
                id: 'table.licenses.deleteModal.title',
            },
            { guid },
        ),
        icon: 'warning',
        content: !isLicenseChild ? (
            <Fragment>
                <FontAwesomeIcon icon={faExclamationTriangle}  size="lg" style={{ color: 'red'}} />
                <b>{intl.formatMessage({ id: 'table.licenses.deleteModal.content' })}</b>
            </Fragment>
        ) : '',
        okText: intl.formatMessage({
            id: 'common.yes',
        }),
        cancelText: intl.formatMessage({
            id: 'common.no',
        }),
        okType: 'danger',
        async onOk() {
            const { isSuccess, isUnauthorized, errorMessage,errorDetail } = await deleteLicense(guid);

            if (isSuccess) {
                message.success(
                    intl.formatMessage(
                        {
                            id: 'table.licenses.success',
                        },
                        { guid },
                    ),
                    5,
                );

                refresh();

                return;
            }
            
            Modal.error({
                title: isUnauthorized
                ? intl.formatMessage({ id: 'error.unauthorized.title' })
                : intl.formatMessage({
                    id: 'table.licenses.fail',
                }),
                content: isUnauthorized
                ? intl.formatMessage({ id: 'error.unauthorized.message' })
                : errorDetail
            });
        },
    });
};

const DeleteLicense = ({ intl, guid, refresh, isLicenseChild }) => (
    <Popover content={<FormattedMessage id="table.users.delete" />}>
        <Button htmlType="button" type="danger" onClick={() => showDeleteConfirm(intl, guid, refresh, isLicenseChild)}>
            <FontAwesomeIcon icon="trash-alt" />
        </Button>
    </Popover>
);

DeleteLicense.propTypes = {
    intl: intlShape.isRequired,
    guid: PropTypes.string.isRequired,
    refresh: PropTypes.func.isRequired,
    isLicenseChild: PropTypes.bool.isRequired,
};

export default injectIntl(DeleteLicense);
